import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';

import { ConnectionRequestsService } from '../services/connection-requests.service';
import { Connection, ConnectionDataMap, ConnectionType } from '../interfaces/connection-interface';
import { CardModule } from 'primeng/card';
import { ConnectionFormComponent } from '../modals/conection-form/connection-form.component';
import { BreadcrumbNavigationService, DropdownComponent } from '@angular-monorepo/ui';
import { TableComponent } from '../component/table/table.component';
import { Observable } from 'rxjs';
import { ConnectionsFacadeService } from '../services/connection-facade.service';
import { Button } from 'primeng/button';
import { Breadcrumb } from 'primeng/breadcrumb';
import { RouterLink } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-connections',
  imports: [
    CardModule,
    ConnectionFormComponent,
    DropdownComponent,
    TableComponent,
    Button,
    Breadcrumb,
    RouterLink,
    TranslatePipe,
  ],
  providers: [ConnectionRequestsService],
  templateUrl: './connections.component.html',
  styleUrl: './connections.component.scss',
})
export class ConnectionsComponent implements OnInit {
  private facade = inject(ConnectionsFacadeService);

  @Input() connectionsBreadcrumbs = signal<MenuItem[]>([]);
  @Input() breadcrumbRoute = 'connections';
  @Input() useDynamicBreadcrumbs = true;
  connections$!: Observable<Connection[]>;
  connections: Connection[] = [];
  mode: 'create' | 'edit' = 'create';

  dropDownItems = [
    {
      label: 'FTP',
      command: () => this.setCreateMode('ftp'),
    },
    {
      label: 'SFTP',
      command: () => this.setCreateMode('sftp'),
    },
    {
      label: 'Postgresql',
      command: () => this.setCreateMode('postgresql'),
    },
    {
      label: 'Rest',
      command: () => this.setCreateMode('rest'),
    },
    {
      label: 'Restlet',
      command: () => this.setCreateMode('restlet'),
    },
    {
      label: 'Netsuite',
      command: () => this.setCreateMode('netsuite'),
    },
  ];

  private breadcrumbNavigationService = inject(BreadcrumbNavigationService);

  public displayBreadcrumbs = computed(() => {
    if (this.useDynamicBreadcrumbs) {
      return this.breadcrumbNavigationService.generateBreadcrumbs(this.breadcrumbRoute);
    }
    return this.connectionsBreadcrumbs();
  });

  ngOnInit() {
    this.connections$ = this.facade.connections$;
    this.fetchData();

    if (this.useDynamicBreadcrumbs && this.breadcrumbRoute === 'connections') {
      this.breadcrumbNavigationService.setConnectionsBreadcrumbs();
    }

    if (this.useDynamicBreadcrumbs) {
      this.breadcrumbNavigationService.navigation$.subscribe(() => {
        console.log('displayBreadcrumbs', this.displayBreadcrumbs());
      });
    }
  }

  setCreateMode(type: ConnectionType) {
    this.facade.setNewConnection(type);
    this.mode = 'create';
  }

  handleDelete(status: boolean) {
    if (status) {
      this.fetchData();
    }
  }

  handleFormSubmit(values: ConnectionDataMap[ConnectionType]) {
    this.facade.getCurrentConnection().subscribe((connection) => {
      if (!connection) return;
      const op$ =
        this.mode === 'create'
          ? this.facade.addConnection(connection, values)
          : this.facade.updateConnection(connection, values);
      op$.subscribe();
    });
  }

  handleUpdateConnection(connection: Connection) {
    this.facade.setConnection(connection);
    this.mode = 'edit';
  }

  private fetchData() {
    this.connections$.subscribe((connections) => {
      this.connections = connections;
    });
  }
}
